import { render, staticRenderFns } from "./PeriodInfo.vue?vue&type=template&id=b503f158&"
import script from "./PeriodInfo.vue?vue&type=script&lang=js&"
export * from "./PeriodInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports